import { TableField } from "../table-field";

export const fieldsEnviosSM: TableField[] = [
  {
    key: "Id",
    label: "ID",
    tdClass: "align-middle",
    thClass: "text-center",
    sortable: false,
  },
  {
    key: "Nome",
    label: "UG",
    tdClass: "align-middle",
    thClass: "text-center",
    sortable: false,
  },
  {
    key: "Ano",
    label: "Exercício",
    tdClass: "align-middle",
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
  },
  {
    key: "Mes",
    label: "Mês Ref.",
    tdClass: "align-middle",
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
  },
  {
    key: "IdSistema",
    label: "Tipo de Prestação",
    tdClass: "align-middle",
    thClass: ["text-center", "quebrarPorPalavra"],
    sortable: false,
  },
  {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions"],
    thClass: "text-center",
    sortable: false,
  },
];
